export const API_PARAMS = {
  // exclude_untagged is needed to remove default variables
  exclude_untagged: 'true',
  tags: 'document_stapling',
}
